export default {"src":"/_next/static/media/wine-enthusiast.b11d206a.svg","height":24,"width":142,"blurWidth":0,"blurHeight":0};